import SidePanel from '~/components/SidePanel.jsx';
import { useSchedulingFormQuery } from '~/lib/Queries';
import Loading from '~/components/Loading';
import Question from '~/components/forms/Question';
import { useMemo } from 'react';

const EditFormAdminScheduling = ({
    isOpen,
    onClose,
    answers,
    setAnswers,
    formId,
    eventTypeId,
}) => {
    // Query all the fields for the given form
    const { data, isLoading } = useSchedulingFormQuery(eventTypeId, formId);
    const questions = data?.questions;

    const sectionQuestions = useMemo(() => {
        const sections = {};
        const sectionQuestions = [];

        if (!questions) {
            return [];
        }

        questions.forEach(q => {
            if (!sections[q.form_section_id]) {
                sections[q.form_section_id] = [];
                sectionQuestions.push({
                    section_id: q.form_section_id,
                    questions: sections[q.form_section_id], // This reference the same object, so updated from push and preserves order
                });
            }
            sections[q.form_section_id].push(q);
        });

        return sectionQuestions;
    }, [questions]);

    return (
        <SidePanel
            isOpen={isOpen}
            onClose={onClose}
            title="Edit Form Fields"
            showSave={true}
            showBackArrow={true}
            onSave={onClose}
            onCancel={() => {
                setAnswers({});
                onClose();
            }}
        >
            {isLoading && <Loading />}
            {!isLoading && (
                <div>
                    {sectionQuestions.map((section, idx) => (
                        <div
                            className={
                                idx > 0
                                    ? 'border-t border-gray-400 mt-6 pt-6'
                                    : ''
                            }
                            key={section.section_id}
                        >
                            {section.questions.map(q => (
                                <Question
                                    question={q}
                                    value={answers[q.id]}
                                    setValue={newValue =>
                                        setAnswers(old => ({
                                            ...old,
                                            [q.id]: newValue,
                                        }))
                                    }
                                    id={`answers.${q.id}`}
                                    className="mb-4"
                                />
                            ))}
                        </div>
                    ))}
                </div>
            )}
        </SidePanel>
    );
};

export default EditFormAdminScheduling;
